<template>
    <!-- MAIN -->
    <section class="section">
    <div class="columns" id="main">
       
        <!-- CONTENT -->
        <main class="container column is-8 main">

             <content-filter v-on:searchClick="searchHandler" :infoMsg="filterMsg"></content-filter>
            
            <!-- search results header -->
             <nav v-if="searchingText.length > 0" class="level-left">
              <div class="level-item">   
                 <p class="subtitle is-4"> 
                   <span>Search results for: {{ searchingText}}</span>
                  </p>
              </div>
              <b-tooltip label="Clear search results"  class="level-item">    
                  <button class="delete" v-on:click="clearSearch">Clear</button>
              </b-tooltip>
            </nav>
            <br>
            
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th>id</th>
                  <th>Table Name</th>
                  <th>Type</th>
                  <th>Entity Id</th>
                  <th>Text</th>
                  <th>Date</th>
                  <th>User Name</th>
                  <th>Email</th>
                   <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in logs" :key="index" v-bind:class="{'is-selected':selectedRowsIds.indexOf(index) > -1}" v-on:click="rowClick(index)">
                  <td>{{item.id}}</td>
                  <td>{{item.tableName}}</td>
                  <td>{{item.type}}</td>
                  <td>{{item.entityId}}</td>
                  <td>{{item.text}}</td>
                  <td>{{Date.parse(item.createDate) | moment("mm/d/YYYY h:mm A")}}</td>
                  <td>{{item.user !== null ? (item.user.name + " " + item.user.familyName) : "Johnessa Doe"}}</td>
                  <td>{{item.user !== null ? item.user.email : ""}}</td>
                  <td>
                  <div class="buttons has-addons" v-on:click="isDeleteModalVisible=true">
                                <p class="control">
                                    <a title="Delete" class="button is-danger">
                                        <span class="icon is-small">
                                            <i class="fas fa-ban"></i>
                                        </span>
                                    </a>
                                </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <pagination class="is-centered" :urlBuilder="urlBuilder" 
                        v-bind:currentPage="page.pageNumber"
                        v-bind:lastPage="page.totalPages"/>
            
            <loading :active.sync="loading" 
            :can-cancel="false" 
            :is-full-page="false"></loading>
               <delete-confirmer v-if="isDeleteModalVisible" :text="deleteMsg" :header="deleteHeader" 
        v-on:close="closeLogsDeleteWindow" v-on:delete="deleteLogs"/>
        </main>

        <!--END CONTENT -->      

    </div>    
    </section>
    <!-- END MAIN -->
</template>
<script>
//import this.HTTP from "../Http";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import * as Oidc from "oidc-client";

import Pagination from "vue-bulma-pagination/src/Pagination";
import ContentFilter from "../ContentFilter";
import DeleteConfirmer from "../DeleteConfirmer";

export default {
  name: "history-view",
  components: { Loading, Pagination, ContentFilter, DeleteConfirmer },
  data: function() {
    return {
      logs: null,
      selectedRowsIds: [],
      //delete
      isDeleteModalVisible: false,
      deleteHeader: "Are you sure that you wanna delete this part of history?",
      deleteMsg: "This part of history will be losted forever!!!(. Rly",
      deleting: false, //indicating that deleting logs in progress now
      //pagination
      page: {
        pageNumber: 1,
        totalPages: 13,
        pageSize: 10,
        totalItems: -1
      },

      searchingText: "",
      loading: false,

      //change filter params
      filterGroups: [],
      filterType: ""
    };
  },
  computed: {
    filterMsg: function() {
      if (this.page.totalItems > 0)
        return "<strong>" + this.page.totalItems + "</strong> logs";
      else return "";
    }
  },
  methods: {
    getLogs() {
      this.loading = true;
      let query = "logs/";
      if (this.searchingText.length > 0) {
        query += "search/";
      }
      query += this.page.pageNumber + "/" + this.page.pageSize;
      if (
        this.searchingText !== null &&
        this.searchingText !== undefined &&
        this.searchingText.length > 0
      ) {
        query += "/" + this.searchingText;
      }
      this.HTTP.get(query)
        .then(response => {
          this.logs = response.data.entities;
          this.page = response.data.page;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },

    rowClick(index) {
      if (this.selectedRowsIds.indexOf(index) <= -1)
        this.selectedRowsIds.push(index);
      else if (this.isDeleteModalVisible == false) {
        const i = this.selectedRowsIds.indexOf(index);
        this.selectedRowsIds.splice(i, 1);
      }
    },

    //delete
    getDeletedIds() {
      let ids = [];
      this.selectedRowsIds.forEach(id => {
        ids.push(this.logs[id].id);
      });
      return ids;
    },
    deleteLogs() {
      this.HTTP.delete(`logs/` + this.getDeletedIds())
        .then(response => {
          this.selectedRowsIds = [];
          this.closeLogsDeleteWindow();
        })
        .catch(e => {
          console.log(e);
        });
    },
    closeLogsDeleteWindow() {
      this.isDeleteModalVisible = false;
      this.getLogs();
    },
    //pagination

    urlBuilder(page) {
      return { query: { ...this.$route.query, page } }; // Changing page in location query
    },
    pushUrl() {
      this.$router.push({
        path: "Logs",
        query: {
          page: this.page.pageNumber,
          search: this.searchingText
        }
      });
    },

    //search
    searchHandler(searchingText) {
      this.searchingText = searchingText;
    },
    clearSearch() {
      this.searchingText = "";
      this.page.pageNumber = 1;
    }
  },
  created() {
    if (this.cardsCount) {
      this.page.pageSize = this.cardsCount;
    }
    this.loading = true;
    this.HTTP.load(); //.then(() => {
    this.getLogs();
    //   });
  },
  watch: {
    $route(to, from) {
      if (to.query.page != null && to.query.page != undefined) {
        this.page.pageNumber = parseInt(to.query.page);
        this.searchingText = to.query.search;
      }

      this.getLogs();
    },
    searchingText: function(val) {
      this.pushUrl();
    },
    page: function(val) {
      this.pushUrl();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/History.Vue